import React from 'react'

// Types
import { LayoutProps } from '../types'

// Components 
import { Modal } from '../../modules/modal'

const Layout: React.FC<LayoutProps> = (props) => {
  const { className } = props
  return (
    <>
      <div
        {...props}
        className={(className || '')}
      />
      <Modal />
    </>
  )
}


export default Layout
